import React from 'react'

import { Heading } from 'core'

import css from './style.scss'

/**
 * Shared shell for the events-page sidebar blocks. Deliberately transparent —
 * the sidebar column already carries its own background — and the rule between
 * blocks is CSS rather than markup so admins never have to add dividers.
 */
const SidebarPanel = ({ header, children }) => (
  <section className={css.panel}>
    {header && (
      <Heading size='h5' as='h2' weight='semibold' noMargin>{header}</Heading>
    )}
    <div className={css.panelBody}>{children}</div>
  </section>
)

SidebarPanel.propTypes = {
  header: React.PropTypes.string,
  children: React.PropTypes.node
}

export default SidebarPanel
